import { Button, CardBody, Col, Form, ListGroup, Modal, Stack } from "react-bootstrap";
import ImageUploader from "../../components/forms/image_uploader/ImageUploader";
import PanelCard from "../../components/layout/panel/PanelCard";
import PanelRow from "../../components/layout/panel/PanelRow";
import { useUpdatePropic } from "../../api/query_hooks/user";
import Propic from "../../components/images/propic/Propic";
import Panel from "../../components/layout/panel/Panel";
import { useState } from "react";
import 'boxicons';
import { getPropicUrl } from "../../api/endpoints";

const AccountDashboard = ({user}) => {

    return (
        <Panel className="py-5 ps-0 pe-md-3">
            <PanelRow>
                <InfoCard user={user} />
                <SecurityCard user={user} />
            </PanelRow>
            <PanelRow>
                <PropicCard user={user} />
                <BalanceCard user={user} />
            </PanelRow>
        </Panel>
    );
}

const InfoCard = ({user}) => {
    return (
        <PanelCard size={"sm"} header={"Account Info"} >
            <ListGroup className="col-12 px-2 py-2 py-md-4 gap-3">
                {/* <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="text-white-50 col-5 col-md-4 user-select-none">Name</Col>
                    <Col >{user?.firstName+' '+user?.lastName}</Col>
                </ListGroup.Item> */}
                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="text-white-50 col-5 col-md-4 user-select-none">Username</Col>
                    <Col >{user?.username}</Col>
                </ListGroup.Item>
                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="text-white-50 col-5 col-md-4 user-select-none">Email</Col>
                    <Col>{user?.email}</Col>
                </ListGroup.Item>
                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="text-white-50 col-5 col-md-4 user-select-none">Phone</Col>
                    <Col>XXX-XXXX-XXX</Col>
                </ListGroup.Item>
            </ListGroup>
        </PanelCard>
    );
}

const SecurityCard = ({user}) => {
    return (
        <PanelCard size={"sm"} header={"Security Summary"} >
            <ListGroup className="d-flex px-2 py-4 user-select-none">
                <ListGroup.Item className="bg-dark text-light">
                    {!!(user?.verified) &&
                        <div className="d-flex">
                            <box-icon color='#14A44D' type='solid' name='check-circle'></box-icon>
                            <p className="mx-3">Email Verified</p> 
                        </div>
                    }
                    {!user?.verified &&
                        <div className="d-flex">
                            <box-icon color='#DC3545' name='x-circle' type='solid' ></box-icon>
                            <p className="mx-3">Email not verified</p>
                        </div>
                    }
                </ListGroup.Item>
                <ListGroup.Item className="bg-dark text-light">
                    <div className="d-flex">
                        <box-icon color='#9FA6B2' name='x-circle' type='solid' ></box-icon>
                        <p className="mx-3 text-white-50">2FA not available</p>
                    </div>
                </ListGroup.Item>
                <ListGroup.Item className="bg-dark text-light">
                    <div className="d-flex">
                        <box-icon color='#9FA6B2' name='x-circle' type='solid' ></box-icon>
                        <p className="mx-3 text-white-50">Phone number not available</p>
                    </div>
                </ListGroup.Item>
            </ListGroup>
        </PanelCard>
    );
}

const PropicCard = ({user}) => {

    const [show, setShow] = useState(false);
    const [images, setImages] = useState([]);

    const mutation = useUpdatePropic();

    const updatePropic = (e) => {
        e.preventDefault();

        const fd = new FormData();
        fd.append("image", images[0]);

        mutation.mutate(fd);

        setShow(false);
    }


    return (
        <>
            <Modal size="sm" show={show} centered onHide={() => setShow(false)} >
                <Modal.Body className="d-flex flex-column bg-dark p-4 border-none rounded">
                    <Form className="d-flex flex-column px-2" onSubmit={updatePropic}>
                        <ImageUploader className="d-flex flex-column justify-content-center mb-4" label="Upload a new profile picture" images={images} setImages={setImages} fileLimit={1} />
                        <Stack className="gap-2">
                            {(images.length > 0) &&
                                <Button className="justify-self-center" variant="warning" type="submit">
                                    Update profile picture
                                </Button>
                            }
                            <Button className="justify-self-center border-secondary" variant="dark" onClick={() => setShow(false)}>
                                Cancel
                            </Button>
                        </Stack>
                    </Form>
                </Modal.Body>
            </Modal>
            <PanelCard size={"sm"} header={"Profile picture"} >
                <CardBody className="px-2 text-white-50 user-select-none">
                    <Propic className="w-30 mx-3" src={getPropicUrl(user?.propic)} onClick={() => setShow(true)} />
                </CardBody>
            </PanelCard>
        </>
    )
}

const BalanceCard = ({user}) => {
    return (
        <PanelCard size={"sm"} header={"Card 4"} >
            <CardBody className="fs-3 px-5">Some other info</CardBody>
        </PanelCard>
    );
}

export default AccountDashboard;